import { connect } from 'react-redux'
import { removeFromProductCompare } from 'actions/removeFromProductCompare'
import CompareTrayItem from './CompareTrayItem'

const mapDispatchToProps = (dispatch, { skuId }) => ({
  handleRemove() {
    dispatch(removeFromProductCompare(skuId))
  }
})

export default connect(null, mapDispatchToProps)(CompareTrayItem)
